import { LensTheme } from '@diligentcorp/atlas-theme-mui-lens';
import { useTheme } from '@mui/material';
import React from 'react';
import { Badge } from 'src/components/atoms/Badge';
import {
  autoClosedColorResolver,
  draftColorResolver,
  pendingMitigationColorResolver,
  publishedColorResolver,
} from 'src/components/atlas/organisms/helpers/sharedStatusColorResolvers';
import { BadgeVariant } from 'src/components/atoms/Badge/Badge.styles';
import { FormStatusTab } from '../types';

interface CategoryDetailsStatusBadgeProps {
  variant?: BadgeVariant;
  text: string;
  $status?: FormStatusTab;
  'data-testid'?: string;
}

const STATUS_RESOLVERS: Partial<
  Record<
    FormStatusTab,
    (tokens: LensTheme['tokens']) => { backgroundColor: string; color: string }
  >
> = {
  [FormStatusTab.ACTIVE]: publishedColorResolver,
  [FormStatusTab.DRAFTS]: draftColorResolver,
  [FormStatusTab.UNPUBLISHED]: pendingMitigationColorResolver,
  [FormStatusTab.ARCHIVED]: autoClosedColorResolver,
};

export const CategoryDetailsStatusBadge: React.FC<
  CategoryDetailsStatusBadgeProps
> = ({ variant = 'custom', text, $status, 'data-testid': dataTestId }) => {
  const theme = useTheme<LensTheme>();
  const resolved =
    $status && theme.tokens
      ? STATUS_RESOLVERS[$status]?.(theme.tokens)
      : undefined;

  return (
    <Badge
      variant={variant}
      text={text}
      color={resolved?.color}
      background-color={resolved?.backgroundColor}
      border-color={resolved?.backgroundColor}
      data-testid={dataTestId}
    />
  );
};
